'use client';

import Script from 'next/script';

function GA4PixelInternal() {
  return (
    <>
      <Script
        id="google-tag-analytics-script"
        strategy="lazyOnload"
        async
        src="https://www.googletagmanager.com/gtag/js?id=G-V2WCQ5LPWW"
      />
      <Script
        id="google-tag-analytics-loader"
        strategy="lazyOnload"
        dangerouslySetInnerHTML={{
          __html: `window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'G-V2WCQ5LPWW');`,
        }}
      />
    </>
  );
}

export function GA4Pixel() {
  return <GA4PixelInternal />;
}
